import * as pdfjsLib from "pdfjs-dist";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export const MAX_PDF_SIZE_BYTES = 1 * 1024 * 1024; // 1MB
export const MAX_TEXT_WORDS = 1000;

export function countWords(text: string): number {
    const trimmed = text.trim();
    if (!trimmed) return 0;
    return trimmed.split(/\s+/).filter(Boolean).length;
}

export function validateTextMessage(text: string, scenario: "A" | "B" = "A"): string | null {
    const words = countWords(text);

    if (words === 0) {
        return "Το μήνυμα δεν μπορεί να είναι κενό.";
    }

    if (words > MAX_TEXT_WORDS) {
        return `Το κείμενο δεν μπορεί να ξεπερνά τις ${MAX_TEXT_WORDS} λέξεις.`;
    }

    if (scenario === "B") {
        return "Το κείμενο δεν μπορεί να είναι παραπλανητικό.";
    }

    return null;
}

export async function getPdfPageCount(file: File): Promise<number> {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    return pdf.numPages;
}

/** Κείμενο 1ης σελίδας για έλεγχο περιεχομένου (μετά την επικύρωση σελίδων). */
export async function extractPdfTextFirstPage(file: File): Promise<string> {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
    const page = await pdf.getPage(1);
    const textContent = await page.getTextContent();
    const parts: string[] = [];
    for (const item of textContent.items) {
        if (item && typeof item === "object" && "str" in item && typeof item.str === "string") {
            parts.push(item.str);
        }
    }
    return parts.join(" ").replace(/\s+/g, " ").trim();
}

export async function validatePdfFile(file: File): Promise<string | null> {
    if (file.type !== "application/pdf") {
        return "Επιτρέπονται μόνο αρχεία PDF.";
    }

    if (file.size > MAX_PDF_SIZE_BYTES) {
        return "Το αρχείο πρέπει να είναι έως 1MB.";
    }

    try {
        const pages = await getPdfPageCount(file);

        if (pages > 1) {
            return "Το PDF πρέπει να περιέχει μόνο 1 σελίδα.";
        }
    } catch (error) {
        console.error("PDF validation error:", error);
        return "Αδυναμία ανάγνωσης του PDF.";
    }

    return null;
}